import HomeCardModel from './HomeCard.model';
import VideoCardModel from './VideoCard.model';

export default class HomeCardsModel {
  constructor({
    cards: {
      news,
      selections,
    },
  } = { cards: {} }) {
    this.news = news?.cards?.map((card) => new HomeCardModel(card));
    this.newsFreeText = news?.free_text;
    this.selectionsFreeText = selections?.free_text;
    this.selectionsBmc = selections?.bmc;
    this.selections = selections?.cards?.map((card) => new HomeCardModel(card));
    this.newsVideo = news?.video_title ? new VideoCardModel(news) : null;
  }

  getNewsFreeText() {
    return this.newsFreeText;
  }

  getSelectionsFreeText() {
    return this.selectionsFreeText;
  }

  getSelectionsBmc() {
    return this.selectionsBmc;
  }

  getNewsList() {
    return this.news || [];
  }

  getSelections() {
    return this.selections || [];
  }

  getNewsVideo() {
    return this.newsVideo;
  }
}
